import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";

import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";

interface AuditEventDataModalProps {
  eventData: string | null;
  eventType: string;
  eventId: number;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  sx?: any;
}

const formatEventData = (data: string | null): string => {
  if (!data) return "No data available";
  
  try {
    const parsed = JSON.parse(data);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return data;
  }
};

export const ViewAuditEventDataModal = (props: AuditEventDataModalProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        disabled={props.disabled}
        size={props.size}
        sx={props.sx}
      >
        <VisibilityIcon />
      </IconButton>
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Audit Event Data - {props.eventType} (ID: {props.eventId})
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography variant="h6" gutterBottom>
              Event Data:
            </Typography>
            <pre
              style={{
                backgroundColor: '#f5f5f5',
                padding: '16px',
                borderRadius: '4px',
                fontSize: '14px',
                fontFamily: 'Monaco, Consolas, "Lucida Console", monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxHeight: '400px',
                overflow: 'auto',
                border: '1px solid #ddd',
              }}
            >
              {formatEventData(props.eventData)}
            </pre>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            variant="contained"
            size="small"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};